import { RoleType } from 'bluetail-globals';
import { AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import axiosApis from '../../common/apis/axiosApis';

type EditUserInfoParams = {
    company_id: number;
    first_name: string;
    last_name: string;
    email: string;
    marketing_user_type: string;
    login_expiry: string | null;
    role_id: RoleType;
}

type EditUserInfoResponse = {
    message: string;
}

async function editUserInfo(userId: number, params: EditUserInfoParams): Promise<AxiosResponse<EditUserInfoResponse>> {
  const userDetails = JSON.parse(localStorage.getItem('adminDetails')) as {token: string;};

  return axiosApis.put(`/admin/editAccountUser/${userId}`, params, {
    headers: {
      Authorization: userDetails.token,
      'Content-Type': 'application/json',
    },
  });
}

function useEditUserInfo(userId: number): UseMutationResult<AxiosResponse<EditUserInfoResponse>, Error, EditUserInfoParams, unknown> {
  return useMutation({
    mutationFn: (params) => editUserInfo(userId, params),
  });
}

export default useEditUserInfo;
